import { Box, Chip as MuiChip, Typography } from '@mui/material';

import { rosterPayerLine } from '../copy';
import { rosterChipStrip } from '../roster';
import type { FoldedPayer } from '../types';

import { StateChip } from './StateChip';

export interface RosterChipStripProps {
  payers: FoldedPayer[];
  liveCount: number;
  unknownCount?: number;
}

/**
 * AC-16: one small chip per non-live payer (max 4, then "+N"), plus the
 * "N payers · N live" summary line.
 */
export function RosterChipStrip({ payers, liveCount, unknownCount = 0 }: RosterChipStripProps) {
  const { chips, overflowCount } = rosterChipStrip(payers);

  return (
    <Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
        {chips.map(chip => (
          <StateChip key={chip.payerId} state={chip.state} label={chip.label} />
        ))}
        {overflowCount > 0 && (
          <MuiChip
            label={`+${overflowCount}`}
            size="small"
            sx={{
              height: 20,
              fontSize: '11px',
              fontWeight: 600,
              backgroundColor: 'grey.200',
              color: 'text.secondary',
              borderRadius: '10px',
            }}
          />
        )}
      </Box>
      <Typography
        sx={{ fontSize: '11px', color: 'text.disabled', fontFamily: 'monospace', mt: 0.5 }}
      >
        {rosterPayerLine(payers.length + liveCount, liveCount)}
      </Typography>
      {unknownCount > 0 && (
        <Typography variant="caption" color="text.secondary">
          {unknownCount} claim receipt {unknownCount === 1 ? 'check' : 'checks'} unknown
        </Typography>
      )}
    </Box>
  );
}
